import { motion } from "framer-motion";
import { useContent } from "../../i18n/useContent";
import { Reveal, RevealGroup, revealItemVariants } from "../ui/Reveal";
import "./About.css";

function About() {
  const { about, objectives, site } = useContent();

  return (
    <section id="nosotros" className="section about">
      <div className="container">
        <div className="about-top">
          <Reveal className="about-story">
            <div className="section-head">
              <span className="eyebrow">{about.eyebrow}</span>
              <h2 className="section-title">{about.title}</h2>
            </div>
            {about.paragraphs.map((paragraph, index) => (
              <p className="about-paragraph" key={index}>
                {paragraph}
              </p>
            ))}
          </Reveal>

          <Reveal className="about-pillars" delay={0.15} y={28}>
            <article className="about-pillar-card">
              <span className="about-pillar-label">{about.mission.label}</span>
              <p className="about-pillar-text">{about.mission.text}</p>
            </article>
            <article className="about-pillar-card about-pillar-card--accent">
              <span className="about-pillar-label">{about.vision.label}</span>
              <p className="about-pillar-text">{about.vision.text}</p>
            </article>
          </Reveal>
        </div>

        <div className="about-motto-wrap">
          <span className="about-motto-rule" aria-hidden="true" />
          <p className="about-motto">{site.motto}</p>
        </div>

        <RevealGroup className="about-objectives" stagger={0.1}>
          {objectives.map((objective, index) => (
            <motion.article
              className="about-objective-card"
              variants={revealItemVariants}
              key={objective.id}
            >
              <span className="about-objective-number" aria-hidden="true">
                {String(index + 1).padStart(2, "0")}
              </span>
              <h3 className="about-objective-title">{objective.title}</h3>
              <p className="about-objective-text">{objective.text}</p>
            </motion.article>
          ))}
        </RevealGroup>
      </div>
    </section>
  );
}

export default About;
